import {computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import errorToast from "../../../components/toast/ErrorToast";


export default class ListMarketplaceUsersFeature {

    constructor(application, navigator) {
        this._application = application;
        this._navigate = navigator;
        this._loaded = false;
        this._users = [];

        makeObservable(this, {
            _loaded: observable,
            _users: observable,
            loaded: computed,
            users: computed
        })
    }

    async load() {
        await this._getUsers()
        this.finishLoading()
    }

    finishLoading() {
        this._loaded = true
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    get users() {
        return this._users;
    }

    set users(value) {
        this._users = value;
    }

    columnsContent() {
        return [
            {id: 'userEmail', label: 'Usuario'},
            {id: 'customers', label: 'Clientes'},
            {id: 'deliverySites', label: 'Puntos de entrega'},
            {id: 'roles', label: 'Roles'},
        ];
    }

    presentedUsers() {
        return this.users.map(user => {
            return this._presentedUser(user);
        });
    }

    _presentedUser(user) {
        return {
            id: user.userEmail,
            userEmail: user.userEmail,
            customers: user.customers,
            deliverySites: user.deliverySites,
            roles: user.roles,
        }
    }

    async _getUsers() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this.users = response.users();
            },
            handlesError: (response) => {
                errorToast('No se pudieron obtener los usuarios')
            }
        });
        return this._application.apiClient().getMarketplaceUsers(responseHandler)
    }

    navigateToAddUserScreen() {
        this._navigate(`/user/create`)
    }

    navigateToAssignRolesScreen(row) {
        this._navigate(`/user/${row.id}`)
    }
}